import React, { useState, useEffect, useContext } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AuthContext } from '../context/AuthContext';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import HeaderComponent from './HeaderComponent';
import { apiService, setupInterceptors } from '../services/apiService';
import { Tag } from 'primereact/tag';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import PdfViewer from './PdfViewer';
import { URLserver } from '../services/urlServer';


const PresupuestosListado = ({productos, toast}) => {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [ presupuestos, setPresupuestos ] = useState([]);
    const { logoutUser } = useContext(AuthContext);

    const [showPdf, setShowPdf] = useState(false);
    const [ presupuestoPdfUrl, setPresupuestoPdfUrl] = useState(null);

    const handleShowPdf = (url_pdf) => {
        setPresupuestoPdfUrl(url_pdf);
        setShowPdf(true); // Mostrar el modal
    };
  
    const handleClosePdf = () => {
      setShowPdf(false); // Cerrar el modal
    };

    const postPresupuestoCobrar = async (id_presupuesto) => {
        try {
            const response = await apiService.postData(`presupuestos/${id_presupuesto}/cobrar_presupuesto/`, {});

            toast.current.show({severity:'success', summary: 'Solicitud Exitosa', detail:'Categoria creada exitosamente!', life: 2000});
            
            getPresupuestos()

        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: error?.response?.data?.error || error?.message || 'Ha ocurrido un error inesperado.',
                life: 3000
            });
                    }
    };


    const getPresupuestos = async () => {
        try {
            const response = await apiService.fetchData('presupuestos/');
            // const productosList = response.data.map(producto => ({
            //     id: producto.id,
            //     categoria_nombre: producto.categoria_nombre,
            //     codigo: producto.codigo,
            //     nombre: producto.nombre,
            //     fabricante: producto.fabricante,
            //     precio_producto: producto.precio_producto,
            //     ult_actualizacion_precio: producto.ult_actualizacion_precio,
            //     cantidad_disponible: producto.cantidad_disponible
            // }));
            setPresupuestos(response.data); 
        } catch (error) {
            console.error('Error al obtener datos:', error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        // Configura el interceptor con la función de logout
        setupInterceptors(logoutUser);
        getPresupuestos();
    }, [logoutUser]);

    const FormatearFecha = (fechaISO) => {
        if (!fechaISO) return ''; // Validar que exista la fecha
        
        const fecha = new Date(fechaISO);
        
        // Formatear fecha en dd/mm/yyyy
        const fechaFormateada = fecha.toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
        
        // Formatear hora en hh:mm
        const horaFormateada = fecha.toLocaleTimeString('es-ES', {
            hour: '2-digit',
            minute: '2-digit'
        });
    
        return `${fechaFormateada} ${horaFormateada}`;
    };

    const getSeverity = (estado) => {
        switch (estado) {
            case "PENDIENTE":
                return "warning"; // Amarillo
            case "ANULADO":
                return "danger"; // Rojo
            case "CONCRETADO":
                return "success"; // Verde
            default:
                return "secondary"; // Gris por defecto
        }
    };

    // Función para mostrar la confirmación antes de cobrar
    const confirmarCobro = (id_presupuesto) => {
        confirmDialog({
            message: '¿Estás seguro de que quieres cobrar este presupuesto?',
            header: 'Confirmar Cobro',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sí, Cobrar',
            rejectLabel: 'Cancelar',
            accept: () => postPresupuestoCobrar(id_presupuesto) // Ejecuta la acción si se confirma
        });
    };

    const accionesTemplate = (rowData) => {
        return (
            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <Button 
                    label="Ver" 
                    icon="pi pi-eye" 
                    className="p-button-info" 
                    size="small"
                    onClick={() => window.open(`presupuesto/${rowData.id}/`, '_blank')}
                    />
                {rowData.estado === "PENDIENTE" && (
                    <Button 
                        label="Cobrar" 
                        icon="pi pi-money-bill" 
                        className="p-button-success" 
                        size="small"
                        onClick={() => confirmarCobro(rowData.id)}
                    />
                )}
                <Button 
                    label="Descargar" 
                    icon="pi pi-download" 
                    className="p-button-info" 
                    size="small"
                    onClick={() => handleShowPdf(rowData.presupuesto_pdf_url)}
                    />
            </div>
        );
    };

    

    return (
        <>
            <HeaderComponent title="Listado de Presupuestos" />
            <div className='col-12 ml-6' style={{ minWidth:"95%", maxWidth:"95%" }}>
                <div className="col-6 p-inputgroup" style={{ marginBottom: '1rem' }}>
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-search" />
                    </span>
                    <InputText 
                        type="search" 
                        onInput={(e) => setGlobalFilter(e.target.value)} 
                        placeholder="Buscar producto..." 
                    />
                </div>

                <DataTable value={presupuestos} globalFilter={globalFilter}>
                    <Column field="id" header="N° Presupuesto" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                    <Column field="cliente_nombre" header="Cliente" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                    <Column field="monto_total_formateado" header="Monto Total" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                    <Column 
                        field="estado" 
                        header="Estado" 
                        style={{ textAlign:"center", fontSize:"15px"}} 
                        alignHeader="center" 
                        headerClassName='header-table-style'
                        body={(rowData) => <Tag value={rowData.estado} severity={getSeverity(rowData.estado)} />} 
                    />
                    <Column field="responsable_usuario" header="Responsable" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                    <Column 
                        field="created_at" 
                        header="Creado el" 
                        style={{ textAlign: "center", fontSize:"15px" }} 
                        alignHeader="center" 
                        headerClassName="header-table-style"
                        body={(rowData) => FormatearFecha(rowData.created_at)} // Aquí se formatea la fecha
                    />
                    <Column header="Acciones" style={{ textAlign:"center" }} headerClassName='header-table-style' alignHeader="center" body={accionesTemplate} />
                </DataTable>
            </div>

            <PdfViewer
                show={showPdf}
                handleClose={handleClosePdf}
                title="Vista del PDF"
            >
                { presupuestoPdfUrl ?
                    <embed src={`${presupuestoPdfUrl}#zoom=75%`}
                        width="1100" height="750" type="application/pdf">
                    </embed>
                    :
                    <p className='text-center'><i>No se ha encontrado el archivo PDF</i></p>
                 }
            </PdfViewer>
        </>
    );
};

export default PresupuestosListado;
